(function () {
  if (window.__vhDescriptionAccordion) return;
  window.__vhDescriptionAccordion = true;

  const headingPattern = /^[✦✧◆◇★]\s*(.+)$/;
  const headingTags = new Set(['H2', 'H3', 'H4', 'H5']);

  function cleanText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function getHeading(node) {
    if (node.nodeType !== Node.ELEMENT_NODE) return null;
    const text = cleanText(node.textContent);
    if (!text) return null;
    if (headingTags.has(node.tagName)) return text.replace(headingPattern, '$1').trim();
    const match = text.match(headingPattern);
    if (!match) return null;
    return match[1].trim();
  }

  function hasUsefulContent(element) {
    return cleanText(element.textContent).length > 0 || element.querySelector('img, video, iframe, table, ul, ol');
  }

  function createSection(title, isFirst) {
    const details = document.createElement('details');
    details.className = 'vh-description-accordion__item';
    if (isFirst) details.open = true;

    const summary = document.createElement('summary');
    summary.className = 'vh-description-accordion__summary';
    const label = document.createElement('span');
    label.textContent = title;
    const icon = document.createElement('span');
    icon.className = 'vh-description-accordion__icon';
    icon.setAttribute('aria-hidden', 'true');
    summary.append(label, icon);

    const content = document.createElement('div');
    content.className = 'vh-description-accordion__content rte';

    details.append(summary, content);
    return { details, content };
  }

  function enhance(container) {
    if (!container || container.dataset.vhDescriptionEnhanced === 'true') return;

    const nodes = Array.from(container.childNodes).filter((node) => {
      if (node.nodeType === Node.TEXT_NODE) return cleanText(node.textContent);
      if (node.nodeType === Node.ELEMENT_NODE) return hasUsefulContent(node);
      return false;
    });

    const hasHeadings = nodes.some((node) => getHeading(node));
    if (!hasHeadings) return;

    const accordion = document.createElement('div');
    accordion.className = 'vh-description-accordion';

    let current = null;
    let sectionCount = 0;

    nodes.forEach((node) => {
      const title = getHeading(node);
      if (title) {
        current = createSection(title, sectionCount === 0);
        accordion.append(current.details);
        sectionCount += 1;
        return;
      }

      if (!current) current = createSection('Detalhes da joia', sectionCount === 0);
      if (!current.details.parentNode) accordion.append(current.details);
      current.content.append(node.cloneNode(true));
    });

    if (!accordion.children.length) return;

    container.innerHTML = '';
    container.append(accordion);
    container.dataset.vhDescriptionEnhanced = 'true';
  }

  function init() {
    document.querySelectorAll('[data-vh-description-accordion]').forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
